import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';
import { DOA_RETURN_POLICY_LISTING_FIELD_KEY } from '../../config/r2rCommercialSeller';
import { Heading } from '../../components';
import { richText } from '../../util/richText';

import css from './ListingPage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

/**
 * Dedicated DOA & Return Policy block when the listing has DOA_policy text.
 *
 * @component
 */
const SectionDoaMaybe = props => {
  const { publicData } = props;
  const policy = String(publicData?.[DOA_RETURN_POLICY_LISTING_FIELD_KEY] || '').trim();

  if (!policy) {
    return null;
  }

  return (
    <section className={css.sectionDoa}>
      <div className={css.sectionHeadingRow}>
        <svg
          className={css.sectionHeaderIcon}
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.9"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M12 3 5 6v5.5c0 4.5 3 7.8 7 10 4-2.2 7-5.5 7-10V6l-7-3Z" fill="none" />
          <path d="m9.5 12.2 1.7 1.8 3.5-3.8" fill="none" />
        </svg>
        <Heading as="h2" rootClassName={css.sectionHeading}>
          <FormattedMessage id="ListingPage.doaTitle" />
        </Heading>
      </div>
      <p className={css.doaBody}>
        {richText(policy, {
          linkify: true,
          longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
          longWordClass: css.longWord,
          breakChars: '/',
        })}
      </p>
    </section>
  );
};

export default SectionDoaMaybe;
